<template>
    <div class="main-container">
      <div v-if="!isFullscreen">
        <!-- Top Section -->
        <h3 class="section-title">Zink Reports</h3>
        <div class="dashboard-grid">
          <div
            class="grid-item"
            v-for="(card, index) in topSectionCards"
            :key="index"
            @click="handleButtonClick(card, index)"
          >
            <v-card>
              <div class="card-content">
                <v-icon class="card-icon">{{ card.icon }}</v-icon>
                <v-card-title>{{ card.title }}</v-card-title>
                <div class="card-description">{{ card.description }}</div>
              </div>
            </v-card>
          </div>
        </div>
  
        <!-- Marketing Section -->
        <h3 class="section-title">MARKETING</h3>
        <div class="dashboard-grid">
          <div
            class="grid-item"
            v-for="(card, index) in marketingSectionCards"
            :key="index"
            @click="handleButtonClick(card, index + topSectionCards.length)"
          >
            <v-card>
              <div class="card-content">
                <v-icon class="card-icon">{{ card.icon }}</v-icon>
                <v-card-title>{{ card.title }}</v-card-title>
                <div class="card-description">{{ card.description }}</div>
              </div>
            </v-card>
          </div>
        </div>
      </div>
  
      <!-- iFrame Section for Fullscreen Report -->
      <div v-if="selectedCard && isFullscreen">
        <group-card :icon="selectedCard.icon" :title="selectedCard.title" padded>
            <MetabaseEmbed
              :key="selectedCardKey"
              :dashboardId="selectedCard.reportId"
              :params="selectedParams"
            />
          <div class="back-button">
            <md-button class="md-primary md-sm" @click="exitFullscreen">
              <md-icon>arrow_back</md-icon>
              <span>Back to Dashboard</span>
            </md-button>
          </div>
        </group-card>
      </div>
    </div>
  </template>
  
  <script>
  import { GroupCard } from "@/components";
  import MetabaseEmbed from "@/components/MetabaseEmbed.vue";
  import { mapGetters } from "vuex";
  
  export default {
    components: {
      GroupCard,
      MetabaseEmbed,
    },
    data() {
      return {
        topSectionCards: [
          { title: "Sales", path:"sales", icon: "paid", description: "Settled income, Lenders & brokers distribution", tabs: [] },
          { title: "Pipeline", path:"pipeline", icon: "timeline", description: "Application counts & Conversion", tabs: [] },
          { title: "Compliance", path:"compliance", icon: "gavel", description: "Review & Pass dashboard", tabs: [] },
          { title: "Billings", path:"billings", icon: "receipt", description: "Service charges by broker", tabs: [] },
        ],
        marketingSectionCards: [
          { title: "Overall Sales Performance", icon: "bar_chart", description: "Overall Sales Performance", reportId: 244 },
          { title: "Broker Auction", icon: "gavel", description: "Lead request & fulfilment", reportId: 245 },
          { title: "Lead Matching", icon: "swap_vert", description: "Lead matching & conversion", reportId: 276 },
        ],
        selectedCard: null,
        selectedParams: null,
        selectedCardKey: 0, // Add a key to force re-rendering
        isFullscreen: false, // Track whether the report is in fullscreen mode
      };
    },
    created(){
      if (this.userHasRole("super-admin")) {
        this.marketingSectionCards.push({
          title: "Leads Forecasting",
          path: "leads",
          icon: "trending_up",
          description: "Volume Expectations & Forecasting Report",
          tabs: []
        });
      }
    },
    computed: {
      ...mapGetters(["userHasRole"]),
    },
    methods: {
      generateParams(reportId) {
        let params = { date: "past1months" }; // Add the date parameter for all reports
        return params;
      },
      handleButtonClick(card, index) {
        if (card.reportId) {
          this.selectedCard = card;
          this.selectedParams = this.generateParams(card.reportId);
          this.selectedCardKey += 1; // Update the key to force re-render
          this.isFullscreen = true; // Enter fullscreen mode
        } else {
          this.$router.push({
            path: `/application/${this.$route.params.id}/reporting-${card.path.toLowerCase()}`,
          });
        }
      },
      exitFullscreen() {
        this.isFullscreen = false; // Exit fullscreen mode
        this.selectedCard = null;
        this.selectedParams = null;
        this.selectedCardKey += 1; // Update the key to reset the component
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  @import "../assets/scss/theme.scss";
  @import "../assets/scss/md-custom/_ausloans-colors.scss";
  
  .main-container {
    padding: 20px;
  }
  
  .dashboard-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* Ensure max 4 per row */
    gap: 20px;
    margin-bottom: 30px; /* Add some space between sections */
  }
  
  .grid-item {
    cursor: pointer;
  }
  
  .v-card {
    padding: 20px;
    transition: transform 0.2s ease-in-out;
  }
  
  .v-card:hover {
    transform: scale(1.05);
  }
  
  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .card-icon {
    font-size: 40px;
  }
  
  .v-card__title {
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  
  .card-description {
    margin-top: 5px;
    font-size: 12px;
    text-align: center;
    color: #555;
  }
  
  .i-frame {
    height: 80vh;
    width: 100%;
  }
  
  .back-button {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
  }
  
  .section-tabs {
    margin: 25px;
  
    &::v-deep .md-tabs-navigation {
      position: sticky;
      top: 0px;
      z-index: 2;
      background: white !important;
  
      & .md-active {
        background-color: $ausloans-blue !important;
        color: white !important;
      }
    }
  
    &::v-deep .md-tabs-content {
      background: transparent !important;
  
      & .md-tab {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
  
  .section-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
  }
  </style>
  